import { Modal, View, Text, Pressable } from 'react-native';
import { higherLowerResultOverlayStyles as styles } from './HigherLowerResultOverlay.styles';
import { HILO_DAILY_COIN_CAP, HILO_TEST_IDS } from '../../../src/quiz/constants/higherLower.constants';

interface HigherLowerResultOverlayProps {
  visible: boolean;
  runLength: number;
  bestRun: number;
  newBest: boolean;
  coinsUsedToday: number;
  onPlayAgain: () => void;
  onMoreGames: () => void;
}

export function HigherLowerResultOverlay({
  visible,
  runLength,
  bestRun,
  newBest,
  coinsUsedToday,
  onPlayAgain,
  onMoreGames,
}: HigherLowerResultOverlayProps) {
  const title = newBest ? 'New best! 🔥' : runLength >= 5 ? 'Nice run' : 'Run over';
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onMoreGames}>
      <View style={styles.backdrop}>
        <View style={styles.card} testID={HILO_TEST_IDS.resultOverlay}>
          <Text style={styles.emoji}>{newBest ? '🏆' : '😅'}</Text>
          <Text style={styles.title}>{title}</Text>

          <View style={styles.scoreRow}>
            <Text style={styles.score}>{runLength}</Text>
            <Text style={styles.scoreLabel}>in a row 🔥</Text>
          </View>

          <Text style={styles.sub}>
            Best run <Text style={styles.subStrong}>{bestRun}</Text>
            {'   ·   '}
            <Text style={styles.subStrong}>{`${coinsUsedToday}/${HILO_DAILY_COIN_CAP}`}</Text> coins banked today
          </Text>

          <Pressable
            testID={HILO_TEST_IDS.playAgain}
            onPress={onPlayAgain}
            style={({ pressed }) => [styles.primaryButton, pressed && styles.pressed]}
          >
            <Text style={styles.primaryText}>Play again</Text>
          </Pressable>
          <Pressable onPress={onMoreGames} style={({ pressed }) => [styles.secondaryButton, pressed && styles.pressed]}>
            <Text style={styles.secondaryText}>More games</Text>
          </Pressable>
        </View>
      </View>
    </Modal>
  );
}
